module.exports = __webpack_public_path__ + "img/exhibition.02f7419a.png";